import { Data, Effect, Option, Result } from 'effect';

import * as Url from 'effect/unstable/http/Url';
import * as UrlParams from 'effect/unstable/http/UrlParams';

class UrlParseError extends Data.TaggedError('@app/Pagination/UrlParseError')<{
  readonly message: string;
  readonly url: string;
}> {}

class PageParamNotFoundError extends Data.TaggedError('@app/Pagination/PageParamNotFoundError')<{
  readonly message: string;
  readonly url: string;
  readonly pageKey: string;
}> {}

class InvalidPageNumberError extends Data.TaggedError('@app/Pagination/InvalidPageNumberError')<{
  readonly message: string;
  readonly value: string;
}> {}

export const extractPageFromUrl = (url: string, pageKey = 'page') =>
  Effect.gen(function* () {
    // Parse URL using Effect Platform with fallback base URL for relative URLs
    const urlResult = Url.fromString(url, 'http://localhost');

    if (Result.isFailure(urlResult)) {
      return yield* new UrlParseError({ message: `Failed to parse URL: ${url}`, url });
    }

    const parsedUrl = urlResult.success;
    const urlParams = Url.urlParams(parsedUrl);
    const pageParam = UrlParams.getFirst(urlParams, pageKey);

    if (Option.isNone(pageParam)) {
      return yield* new PageParamNotFoundError({
        message: `Page parameter '${pageKey}' not found in URL`,
        url,
        pageKey,
      });
    }

    const pageNumber = parseInt(pageParam.value, 10);
    if (Number.isNaN(pageNumber) || pageNumber < 1) {
      return yield* new InvalidPageNumberError({
        message: `Invalid page number: ${pageParam.value}`,
        value: pageParam.value,
      });
    }

    return pageNumber;
  });
